module.exports = __webpack_public_path__ + "img/patacones_rellenos_de_mixtos.e91a55b9.jpg";